type Alignment = "right" | "left" | "center";

type LbColumnType = 'number' | 'text' | 'date' | 'bool' | 'jsonb' | 'xml' | 'USER-DEFINED';

const objLength = (input) => {
	if (input || input === 0) {
		return input.toString().length;
	} else {
		return 0;
	}
};

// input pure values, output
const getLength = (values) => {
	let length = objLength(values[0]);
	for (let i = 1; i < values.length; i ++) {
		if (objLength(values[i]) > length) {
			length = objLength(values[i]);
		}
	}
	return length;
};

// Input pure values, output standard deviation of length
const calculateSd = (values) => {
	const lengths = [];
	for (let i = 0; i < values.length; i ++) {
		if (typeof(values[i]) === "string" || typeof(values[i]) === "object" && values[i] !== null) {
			lengths.push(objLength(values[i]));
		}
	}
	const reducer = (sum, current) => sum + current;
	const sum = lengths.reduce(reducer, 0);
	const mean = sum / lengths.length;
	const reducer2 = (sum2, current) => sum2 + Math.pow((current - mean), 2);
	const variance = lengths.reduce(reducer2, 0) / (lengths.length - 1);
	return Math.pow(variance, 0.5) / mean;
};

const checkType = (values) => {
	for (let i = 0; i < values.length; i ++) {
		if (values[i] === null) {
			continue;
		}
		const currentType = typeof(values[i]);
		if (currentType === "number" || currentType === "string" || currentType === "boolean") { //  || currentType === "date"(this will always return false)
			return currentType;
		}
		if (currentType === "object") {
			return "string";
		}
	}
	return "null";
};

const checkInteger = (values) => {
	for (let i = 0; i < values.length; i ++) {
		if (typeof(values[i]) === "number" && !Number.isInteger(values[i])) {
			return false;
		}
	}
	return true;
};

const checkNumeric = (values) => {
	const updated = [];
	for (let i = 0; i < values.length; i ++) {
		if (isNaN(values[i])) {
			return {
				result: false,
				updated: null
			};
		}
		updated.push(Number(values[i]));
	}
	return {
		result: true,
		updated: values
	};
};

const getSimpleLength = (values) => {
	for (let i = 0; i < values.length; i ++) {
		if (!values[i] === null && !values[i] === undefined) {
			return values[i].length;
		}
	}
	return 0;
};

// Input pure values, output result
export const smartDisplay = (inputs, header, type) => {
	// Validate data
	if (!inputs.length) {
		throw new Error("Input is not a valid array");
	}

	// Get type
	let dataType;
	if (type) {
		dataType = type;
	} else {
		dataType = checkType(inputs);
	}
	if (dataType === "string" || dataType === "uuid") {
		dataType = "text";
	}
	if (dataType === "boolean") {
		dataType = "bool";
	}
	if (!dataType) {
		throw new Error("Cannot get input type");
	}

	if (dataType === "text") {
		const result = checkNumeric(inputs);
		if (result.result) {
			inputs = result.updated;
			dataType = "number";
		}
	}

	// xml, json and jsonb
	if (dataType === "xml" || dataType === "jsonb" || dataType === "json") {
		return {
			alignment: "left",
			size: 64
		};
	}

	// bool, timestamp and date
	if (dataType === "bool" || dataType === "timestamp without time zone" || dataType === "timestamp with time zone" || dataType === "date") {
		const length = getSimpleLength(inputs);
		return {
			alignment: "center",
			size: Math.max(length, header.toString().length)
		};
	}

	// number
	if (dataType === "number") {
		const length = getLength(inputs);
		if (checkInteger(inputs)) {
			// Integer number
			return {
				alignment: "center",
				size: Math.max(length, header.toString().length)
			};
		} else {
			// Non-Integer number
			return {
				alignment: "right",
				size: Math.max(length, header.toString().length)
			};
		}
	}

	// text
	if (dataType === "text") {
		const length = getLength(inputs);
		const sd = calculateSd(inputs);
		const align = sd > 0.5 ? "left" : "center";
		const size = Math.min(Math.max(length, header.toString().length), 64);
		return {
			alignment: align,
			size: size,
		};
	}

	// user defined
	if (dataType === "USER-DEFINED") {
		return {
			alignment: "left",
			size: 0
		};
	}

	// null
	if (dataType === "null") {
		return {
			alignment: "left",
			size: header.toString().length
		};
	}

	// Anything else // TODO
	return {
		alignment: "left",
		size: 64
	};
};
